import { useNavigate } from 'react-router-dom';
import { CategoryCard } from './category-card';
import { CategoryCardSkeleton } from '../skeletons/category-card.skeleton';

export const Categories = ({ categoryList, isLoading }) => {
  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    if (!category.disabled) {
      navigate(`${category.route}`);
    }
  };

  return (
    <div className="w-full py-6">
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {isLoading ?
          [...Array(8)].map((_, index) => <CategoryCardSkeleton key={index} />) :
          categoryList.map((category, index) => (
            <CategoryCard
              category={category}
              key={index}
              handleClick={handleCategoryClick}
            />
          ))
        }
      </div>
    </div>
  );
};